import BaseApi from './base'

// Downloading a ciphered firmware image S3-fetches the raw object, then
// ECDSA-signs and ECIES-encrypts the WHOLE file synchronously inside the
// request, before it is buffered back through the backoffice proxy. The
// shared axios instance's default timeout (`REACT_APP_AXIOS_REQUEST_TIMEOUT
// || 3000`, i.e. 3 seconds) is far too short for that. Override PER CALL,
// here only — never raise the global default (matches the kit-configuration
// upload's own 60s override, since it is the same "whole-file, not chatty"
// shape).
const CIPHERED_FIRMWARE_DOWNLOAD_TIMEOUT = 60000

class Per extends BaseApi {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.fleetURL}/backoffice`
  }

  getPers = (query) => this.client.get(`pers?${query}`)

  getPerCurrentData = (id) => this.client.get(`pers/${id}/current-data`)

  getPerBy = (id) => this.client.get(`pers/${id}`)

  addPer = (data) => this.client.post('pers', data)

  updatePer = (id, data) => this.client.patch(`pers/${id}`, data)

  deletePer = (id) => this.client.delete(`pers/${id}`)

  getPerAlerts = (id, query) =>
    this.client.get(`pers/${id}/pers-alerts?${query}`)

  publishIOTService = (data) =>
    this.client.post('pers/iot-service/publish', data, {
      baseURL: `${process.env.REACT_APP_FLEET_API_URL}/api/v2/backoffice`
    })

  getSystemPers = (query) => this.client.get(`systems/pers?${query}`)

  getPerPackageLogs = (query) =>
    this.client.get(`backoffice/pers-package-log?${query}`, {
      baseURL: this.perLogURL
    })

  getVehicleTrips = (query) =>
    this.client.get(`backoffice/vehicle-trips?${query}`, {
      baseURL: this.perLogURL
    })

  getVehicleTripBy = (id) =>
    this.client.get(`backoffice/vehicle-trips/${id}`, {
      baseURL: this.perLogURL
    })

  exportVehicleTripBy = (id) =>
    this.client.get(`backoffice/vehicle-trips/${id}/export`, {
      baseURL: this.perLogURL,
      responseType: 'blob'
    })

  getCompanyPersLinked = (persId) =>
    this.client.get(`pers/${persId}/company-pers-link`, {
      baseURL: this.baseURL
    })

  getPersKitConfiguration = (persId) =>
    this.client.get(`admin/pers/${persId}/kit-configuration`, {
      baseURL: this.baseURL
    })

  getMqttMessageLogs = ({ persId, params }) =>
    this.client.get(`pers/${persId}/mqtt-messages-logs-alert`, { params })

  getDownloadableFirmwareVersions = (id) =>
    this.client.get(
      `pers-firmware-versions/${id}/downloadable-firmware-versions`,
      {
        baseURL: this.baseURL
      }
    )

  getDownloadableKitConfigurationVersions = (id) =>
    this.client.get(
      `pers-firmware-versions/${id}/downloadable-kit-configuration-versions`,
      {
        baseURL: this.baseURL
      }
    )

  prepareEncryption = ({ persId, versionId }) =>
    this.client.post(
      `pers-firmware-versions/pers/${persId}/firmware/${versionId}/prepare-encryption`,
      {},
      {
        baseURL: this.baseURL
      }
    )

  downloadCipheredFirmware = (id, query) =>
    this.client.get(`pers-firmware-versions/${id}/ciphered-firmware?${query}`, {
      responseType: 'blob',
      baseURL: this.baseURL,
      timeout: CIPHERED_FIRMWARE_DOWNLOAD_TIMEOUT
    })
}

export default new Per()
